import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	carouselMacroTitle: {
		id: 'custom-sites-extensions.carousel.manifest.macro-title',
		defaultMessage: 'Carousel',
		description: 'Title of carousel macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	carouselMacroTitleUpdated: {
		id: 'custom-sites-extensions.carousel.manifest.macro-title.updated',
		defaultMessage: 'Carousel [Updated]',
		description:
			'New title of carousel macro with additional copy about the feature being updated. To be displayed in toolbar/shortcut macros dropdown.',
	},
	carouselMacroDescription: {
		id: 'custom-sites-extensions.carousel.manifest.macro-description',
		defaultMessage: 'Create a rotating trio of dynamic frames.',
		description:
			'Description of carousel macro to be displayed in toolbar/shortcut macros dropdown',
	},
});
